import { bunja } from 'bunja';
import { atom } from 'jotai';

import { RankingType } from '@flipster/apis/v2/trading-competition/types';
import { FormattedMessage } from '@flipster/i18n';
import Formatted from '@flipster/react/design-utils/formatted';
import { UsdtCurrency } from '@flipster/utils/constants/currency';
import { numberFormatter } from '@flipster/utils/num';

import { competitionBunja, competitionEventsBunja, competitionTabsBunja } from '../state';

export const competitionContentBunja = bunja(() => {
  const { competitionAtom } = bunja.use(competitionBunja);
  const { selectedEventTabValueAtom } = bunja.use(competitionTabsBunja);
  const { competitionEventContentfulDataAtom } = bunja.use(competitionEventsBunja);

  const eventTabTitleAtom = atom((get) => {
    const selectedEventTabValue = get(selectedEventTabValueAtom);
    const competition = get(competitionAtom);

    if (!selectedEventTabValue) return '';

    switch (selectedEventTabValue) {
      case 'volume':
      case 'pnl':
      case 'roi':
        return (
          <FormattedMessage
            id='Competition.r251215.Up_to_amount_symbol'
            values={{
              amountSymbol: (
                <Formatted.Number
                  value={numberFormatter(competition?.maxPrizePool[selectedEventTabValue as RankingType] || 0)}
                  suffix={UsdtCurrency}
                />
              ),
            }}
          />
        );
      case 'x-mas-etc':
        return <FormattedMessage id='Competition.r251217.Win_travel_package_more_days' values={{ number: 4 }} />;
      default:
        return '';
    }
  });

  const eventTabSubtitleAtom = atom((get) => {
    const selectedEventTabValue = get(selectedEventTabValueAtom);
    const competitionEventContentful = get(competitionEventContentfulDataAtom);

    if (!selectedEventTabValue) return '';

    switch (selectedEventTabValue) {
      case 'volume':
      case 'pnl':
      case 'roi':
        return (
          <FormattedMessage
            id='Competition.r251218.Total_prize_pool_event'
            values={{ event: competitionEventContentful?.label }}
          />
        );
      case 'x-mas-etc':
        return <FormattedMessage id='Competition.r251217.Refer_unlock_bigger_rewards' />;
      default:
        return '';
    }
  });

  return {
    eventTabTitleAtom,
    eventTabSubtitleAtom,
  };
});
competitionContentBunja.debugLabel = 'competitionContentBunja';
